import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import Moment from "react-moment";
import Image from "../Image";
import ReduxLinkDecorator from "../../containers/ReduxLinkDecorator";
import { Popover, Position, Button, Menu, MenuItem } from "@blueprintjs/core";

const CircleMember = ({ user, isSuperUser, showUserActions, takeAction, locale, onMessageClick, myGuid }) => {
  const userContextActions = (
    <Menu>
      {/*<MenuItem*/}
      {/*  icon="endorsed"*/}
      {/*  text={I18n.t("circle_members.make_admin")}*/}
      {/*  onClick={() => {*/}
      {/*    takeAction("make_admin", user);*/}
      {/*  }}*/}
      {/*/>*/}
      <MenuItem
        icon="ban-circle"
        text={I18n.t("circle_members.kick_user")}
        onClick={() => {
          takeAction("kick_user", user);
        }}
        intent="danger"
      />
    </Menu>
  );
  return (
    <div className="user-item">
      <ReduxLinkDecorator goTo={`public-profile/${user.guid}`}>
        <div className="image user-avatar size-56">
          <Image src={user.image_url} alt={user.f_name} />
        </div>
        <div className="meta">
          {isSuperUser ? (
            <div className="context">
              <Translate value="circle_members.circle_creator" />
            </div>
          ) : (
            <div className="context">
              <Translate value="circle_members.circle_member1" />
              <Moment locale={locale} fromNow ago>
                {user.c_at}
              </Moment>
              <Translate value="circle_members.circle_member2" />
            </div>
          )}
          <div className="name">
            {user.f_name} {user.l_name}
          </div>
        </div>
      </ReduxLinkDecorator>
      <div className="user-actions">
        {showUserActions && isSuperUser &&(
          <Popover content={userContextActions} position={Position.BOTTOM}>
            <Button intent="primary" className="gray-outline" icon="more" />
          </Popover>
        )}
        {/*{!(myGuid==user.guid) && (*/}
        {/*  <Button onClick={_ => onMessageClick(user.guid)} intent="primary secondary-color" icon="chat" />*/}
        {/*)}*/}
      </div>
    </div>
  );
};

export default CircleMember;
